/**
 * Centralized icon registration for Ionic standalone components
 * This file registers all icons used throughout the mobile app
 */
import { addIcons } from 'ionicons';
import {
  add,
  addOutline,
  airplane,
  airplaneOutline,
  alertCircle,
  alertCircleOutline,
  arrowBack,
  arrowDownCircleOutline,
  arrowForward,
  arrowForwardCircle,
  arrowRedoCircleOutline,
  arrowUndo,
  attach,
  attachOutline,
  bookSharp,
  briefcaseOutline,
  bulbOutline,
  calendar,
  calendarClearOutline,
  calendarOutline,
  call,
  camera,
  caretDown,
  chatbox,
  chatbubbles,
  checkmark,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronBack,
  chevronBackOutline,
  chevronDown,
  chevronDownOutline,
  chevronForwardOutline,
  close,
  closeCircle,
  closeCircleOutline,
  cloudOfflineOutline,
  colorWandOutline,
  create,
  documentOutline,
  ellipsisHorizontal,
  eyeOffOutline,
  eyeOutline,
  funnelOutline,
  headsetSharp,
  helpBuoySharp,
  helpCircle,
  infiniteOutline,
  informationCircle,
  informationCircleSharp,
  linkOutline,
  list,
  locationOutline,
  locationSharp,
  lockClosedSharp,
  logoMicrosoft,
  logoWhatsapp,
  medicalOutline,
  notifications,
  notificationsSharp,
  openOutline,
  options,
  pause,
  people,
  person,
  personAdd,
  personCircle,
  personCircleOutline,
  pin,
  pinOutline,
  play,
  playForward,
  playOutline,
  pulseOutline,
  reorderTwoOutline,
  returnDownBack,
  ribbon,
  school,
  send,
  settingsSharp,
  square,
  star,
  starOutline,
  stopOutline,
  time,
  timeOutline,
  timerOutline,
  train,
  trainOutline,
  trash,
  trashOutline,
  warningOutline,
  chevronUpOutline,
} from 'ionicons/icons';

/**
 * Registers all icons used in the app
 * Call this once in app.component.ts constructor
 */
export function registerAppIcons(): void {
  addIcons({
    add,
    addOutline,
    airplane,
    alertCircle,
    alertCircleOutline,
    arrowBack,
    arrowDownCircleOutline,
    arrowForward,
    arrowRedoCircleOutline,
    arrowUndo,
    attach,
    attachOutline,
    bookSharp,
    bulbOutline,
    calendar,
    calendarClearOutline,
    calendarOutline,
    call,
    camera,
    caretDown,
    chatbox,
    chatbubbles,
    checkmark,
    checkmarkCircle,
    checkmarkCircleOutline,
    checkmarkOutline,
    chevronBack,
    chevronBackOutline,
    chevronDown,
    chevronDownOutline,
    chevronForwardOutline,
    close,
    closeCircle,
    cloudOfflineOutline,
    create,
    documentOutline,
    ellipsisHorizontal,
    eyeOffOutline,
    eyeOutline,
    funnelOutline,
    headsetSharp,
    helpCircle,
    infiniteOutline,
    informationCircle,
    linkOutline,
    list,
    locationOutline,
    logoMicrosoft,
    notifications,
    notificationsSharp,
    options,
    people,
    person,
    personAdd,
    personCircle,
    personCircleOutline,
    pulseOutline,
    reorderTwoOutline,
    returnDownBack,
    ribbon,
    school,
    send,
    settingsSharp,
    time,
    timerOutline,
    trainOutline,
    trash,
    trashOutline,
    warningOutline,
    helpBuoySharp,
    lockClosedSharp,
    informationCircleSharp,
    colorWandOutline,
    briefcaseOutline,
    medicalOutline,
    airplaneOutline,
    star,
    starOutline,
    locationSharp,
    square,
    pause,
    playForward,
    timeOutline,
    closeCircleOutline,
    pin,
    pinOutline,
    train,
    openOutline,
    play,
    playOutline,
    stopOutline,
    arrowForwardCircle,
    logoWhatsapp,
    chevronUpOutline,
  });
}
